export const REQUEST_PREOPEN_BASIC_CLAIM = 'REQUEST_PREOPEN_BASIC_CLAIM';
